<zef-dialog
  [open]="state.open"
  [options]="{ restoreFocus: false, disableClose: true }"
  [autoFocus]="false">

  <div class="__content">

    <!-- Warning Card -->
    <zui-tip-card
      theme="warning"
      icon="warning"
      iconAlignment="start">
      <h3 class="__heading">Save Your New Recovery Code</h3>
      <p class="__text">
        You used a recovery code to authenticate. Here is your new replacement code:
      </p>
      <div class="__code-display">
        <zef-copy-to-clipboard
          mode="basic"
          [copyData]="state.code"
          [tooltip]="'Copy code'">
            <code
              [class.is-hidden]="!showCode()"
              class="__code">{{ state.code }}</code>
        </zef-copy-to-clipboard>
        <!-- Show recovery code -->
        <button
          mat-icon-button
          class="fx:ml-0-5"
          type="button"
          (click)="showCode.set(!showCode())">
          <mat-icon fontSet="material-icons-outlined">{{ showCode() ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </div>
      <p class="__important">
        <strong>Important:</strong> This code will only be shown once. Save it in a secure location before continuing.
      </p>
    </zui-tip-card>

    <!-- Action Button -->
    <div class="__actions  fx:pt-1 fx:mt-1">
      <button
        mat-flat-button
        color="accent"
        type="button"
        class="c-button--full"
        (click)="onClose$.next()">
        I've Saved My Code - Continue
      </button>
    </div>

  </div>

</zef-dialog>
